<template>
    <section class="appointment-area section-padding section" id="appointment">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="appointment-form">
                        <h6 class="appointment-title"><i class="fa fa-file-text-o"></i> Lini një takim</h6>
                        <form class="appointment-box" @submit="RuajTakim">
                            <input type="text" placeholder="Emri juaj" class="appointment-field" v-model="form.emri" required>
                            <input type="email" placeholder="Email" required class="appointment-field" v-model="form.email">
                            <input type="number" placeholder="Nr. Telefoni" required class="appointment-field" v-model="form.telefon">
                            <div class="select-group">
                                <div class="single-select-item">
                                    <label><b style="color:black">Dita: </b></label><br>
                                    <select name="sortby" v-model="form.dita" placeholder="Dita" required>
                                        <option value="Hëne">E Hëne</option>
                                        <option value="Martë">E Martë</option>
                                        <option value="Mërkurë">E Mërkurë</option>
                                        <option value="Enjte">E Enjte</option>
                                        <option value="Premte">E Premte</option>
                                        <option value="Shtune">E Shtune</option>
                                    </select>
                                </div>
                                <div class="single-select-item">
                                     <label><b>Orari: </b></label><br>
                                    <select name="sortby" v-model="form.ora">
                                        <option value="09:00">09.00</option>
                                        <option value="10:00">10:00</option>
                                        <option value="11:00">11:00</option>
                                        <option value="12:00">12:00</option>
                                        <option value="13:00">13:00</option>
                                        <option value="14:00">14:00</option>
                                        <option value="15:00">15:00</option>
                                        <option value="16:00">16:00</option>
                                    </select>
                                </div>
                                <div class="single-select-item">
                                     <label><b>Doktoresha: </b></label><br>
                                    <select name="sortby">
                                        <option :value="form.doktoresha">{{form.doktoresha}}</option>
                                    </select>
                                </div>
                            </div>
                            <textarea placeholder="Message" v-model="form.mesazhi" class="textarea-field"></textarea>
                            <button type="submit" class="submit-btn">Ruaj Takimin</button>
                        </form>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="service-provide-area">
                        <div class="section-title title-style-5 text-center">
                            <h2 class="title">Kush jemi?</h2>
                            <p class="paragraph">HELIOS MED,LABORATOR IMUNOLOGJIK – HORMONAL DREJTUAR NGA Dr.  TEUTA FELEQI .</p>
                        </div>
                        <div class="service-provide-wrapper">
                            <!-- service provide item start -->
                            <div v-for="provide in provides" :key="provide.id" class="service-provide-item">
                                <div class="service-provide-icon">
                                    <img :src="provide.icon" alt="service icon">
                                </div>
                                <div class="service-provide-content">
                                    <h6>{{ provide.title }}</h6>
                                    <p>{{ provide.desc }}</p>
                                </div>
                            </div>
                            <!-- service provide item end -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'ChooseUs',
        data () {
            return {
                provides: [
                    {
                        icon: require("../assets/img/home-medical/provide/1.png"), 
                        title: 'Analiza cilësore', 
                        desc: ''
                    },
                    {
                        icon: require("../assets/img/home-medical/provide/2.png"), 
                        title: 'Suport i vazhduar', 
                        desc: ''
                    },
                    {
                        icon: require("../assets/img/home-medical/provide/3.png"), 
                        title: 'Ne kujdesemi për ju', 
                        desc: ''
                    },
                    {
                        icon: require("../assets/img/home-medical/provide/4.png"), 
                        title: 'Gjithmonë pranë jush', 
                        desc: ''
                    },
                ],
                form:{
                    emri:"",
                    telefon:"",
                    email:"",
                    dita:"",
                    ora:"",
                    doktoresha:"Teuta Feleqi",
                    mesazhi:""
                },
                valid_hours: [
                    '08:00','08:30','09:00','09:30',
                    '10:00','10:30','11:00','11:30','12:00','12:30',
                    '13:00','13:30','14:00','14:30','15:00','15:30'
                ]
            }
        },
        methods:{
            RuajTakim(e){
                e.preventDefault();
                const {emri,email,dita,ora} = this.form;
                if(emri === "" || email ==="" || dita === "" || ora ===""){
                    alert("Emri, Email-i, Dita dhe Ora jane te detyrueshme!")
                    return
                }
                axios.post("https://mailserver.helios-med.com/api/mail",this.form)
                    .then(() => {
                        alert("Takimi u ruajt!")
                        this.emptyForm();
                    })
                    .catch(error => {
                        alert(error)
                    })
            },
            emptyForm(){
                this.form = {
                  emri:"",
                  telefon:"",
                  email:"",
                  dita:"",
                  ora:"",
                  doktoresha:"Teuta Feleqi",
                  mesazhi:""
                }
            }
        }
    }
</script>
